// import { Footer3 } from '@/components'
import Footer1 from '../../components/common/Footer1';
import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar';
import ScrollToTop from '../../components/scroll-to-top/ScrollToTop';
import ContactUs from './ContactUs';
import Hero from './Hero';
// @import "5pageAssets/scss/icons.scss";
// @import "5pageAssets/scss/style.scss";
// import "../../5pageAssets/scss/icons.scss"
// import "../../5pageAssets/scss/style.scss"
// import "./5pageAssets/scss/style.scss";
// import "./5pageAssets/scss/icons.scss";


const Contact = () => {
    return (
        <>
              <ScrollToTop />
            <LayoutsNavbar />
            {/* <Hero /> */}

            <ContactUs />
            <Footer1 />

            {/* <Footer3 /> */}
        </>
    );
};

export default Contact;